/**
 * inyourplace-subclip-selector-server
 * Server to generate sports graphics
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: r.hutter@moovit.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The WebhookConfig model module.
 * @module model/WebhookConfig
 * @version 1.0.0
 */
class WebhookConfig {
    /**
     * Constructs a new <code>WebhookConfig</code>.
     * @alias module:model/WebhookConfig
     * @param targets {Object.<String, String>} event type (one of availableEvents) -> absolute http(s) URL
     * @param maxAttempts {Number} 
     * @param retryDelayMs {Number} 
     */
    constructor(targets, maxAttempts, retryDelayMs) { 
        
        WebhookConfig.initialize(this, targets, maxAttempts, retryDelayMs);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, targets, maxAttempts, retryDelayMs) { 
        obj['targets'] = targets;
        obj['maxAttempts'] = maxAttempts;
        obj['retryDelayMs'] = retryDelayMs;
    }

    /**
     * Constructs a <code>WebhookConfig</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/WebhookConfig} obj Optional instance to populate.
     * @return {module:model/WebhookConfig} The populated <code>WebhookConfig</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new WebhookConfig();

            if (data.hasOwnProperty('targets')) {
                obj['targets'] = ApiClient.convertToType(data['targets'], {'String': 'String'});
            }
            if (data.hasOwnProperty('maxAttempts')) {
                obj['maxAttempts'] = ApiClient.convertToType(data['maxAttempts'], 'Number');
            }
            if (data.hasOwnProperty('retryDelayMs')) {
                obj['retryDelayMs'] = ApiClient.convertToType(data['retryDelayMs'], 'Number');
            }
            if (data.hasOwnProperty('secret')) {
                obj['secret'] = ApiClient.convertToType(data['secret'], 'String');
            }
            if (data.hasOwnProperty('secretSet')) {
                obj['secretSet'] = ApiClient.convertToType(data['secretSet'], 'Boolean');
            }
            if (data.hasOwnProperty('availableEvents')) {
                obj['availableEvents'] = ApiClient.convertToType(data['availableEvents'], ['String']);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>WebhookConfig</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>WebhookConfig</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of WebhookConfig.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['secret'] && !(typeof data['secret'] === 'string' || data['secret'] instanceof String)) {
            throw new Error("Expected the field `secret` to be a primitive type in the JSON string but got " + data['secret']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['availableEvents'])) {
            throw new Error("Expected the field `availableEvents` to be an array in the JSON data but got " + data['availableEvents']);
        }

        return true;
    }


}

WebhookConfig.RequiredProperties = ["targets", "maxAttempts", "retryDelayMs"];

/**
 * event type (one of availableEvents) -> absolute http(s) URL
 * @member {Object.<String, String>} targets
 */
WebhookConfig.prototype['targets'] = undefined;

/**
 * @member {Number} maxAttempts
 */
WebhookConfig.prototype['maxAttempts'] = undefined;

/**
 * @member {Number} retryDelayMs
 */
WebhookConfig.prototype['retryDelayMs'] = undefined;

/**
 * HMAC secret; null keeps the stored one, an empty string removes it
 * @member {String} secret
 */
WebhookConfig.prototype['secret'] = undefined;

/**
 * @member {Boolean} secretSet
 */
WebhookConfig.prototype['secretSet'] = undefined;

/**
 * @member {Array.<String>} availableEvents
 */
WebhookConfig.prototype['availableEvents'] = undefined;






export default WebhookConfig;

